import { FormState, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Form } from "@/src/components/ui/form";
import { useSubscribe, useEmit } from "@/src/lib/actions";
import { emptyFiltersForm, FiltersFormT } from "./filters.schema";
import { useCallback, useEffect } from "react";
import { CharterTypes } from "./CharterTypes";
import { Separator } from "../../../components/ui/separator";
import { Country } from "./Country";
import { Operator } from "./Operator";
import { Status } from "./Status";
import { Customer } from "./Customer";
import { Broker } from "./Broker";
import { Hubspot } from "./Hubspot";
import { useBookingsStore } from "@/src/stores/bookingsStore";
import { StartDate } from "./StartDate";
import { WonDate } from "./WonDate";
import { Slug } from "./Slug";
import { Brand } from "./Brand";

export function FiltersForm({ onSave }: { onSave: () => void }) {
  const { filters, setFilters } = useBookingsStore();
  const emit = useEmit<number>("bkg:page");
  const form = useForm<FiltersFormT>({
    resolver: zodResolver(FiltersFormT),
    defaultValues: emptyFiltersForm,
    ...(filters ? { values: { ...emptyFiltersForm, ...filters } } : {}),
    resetOptions: {
      keepDefaultValues: true,
    },
  });

  const onClear = () => {
    form.reset(emptyFiltersForm);
    setFilters({});
    onSave();
  };

  const Radio = form.watch("charterDateType");

  useEffect(() => {
    console.log(Radio);
  }, [Radio]);

  const onSubmit = useCallback(
    form.handleSubmit(
      (data) => {
        const dirtyFields = findCommonFormProps(data, form.formState.dirtyFields);
        setFilters(dirtyFields);
        emit(1);
        onSave();
      },
      () => {
        const values = form.getValues();
        const issues = FiltersFormT.safeParse(values).error?.issues ?? [];
        console.log(issues, "errors");
      },
    ),
    [form],
  );

  useSubscribe("filters:save", onSubmit);
  useSubscribe("filters:clear", onClear);

  return (
    <Form {...form}>
      <form className="flex flex-col gap-6" onSubmit={onSubmit}>
        <Brand />
        <Separator />
        <Status />
        <Separator />
        <Hubspot />
        <Separator />
        <Slug />
        <Separator />
        <StartDate />
        <Separator />
        <WonDate />
        <Separator />
        <Broker />
        <Separator />
        <Customer />
        <Separator />
        <Operator defaultValue={filters?.operator} />
        <Separator />
        <Country defaultValue={filters?.country} />
        <Separator />
        <CharterTypes />
      </form>
    </Form>
  );
}

function findCommonFormProps(
  data: FiltersFormT,
  dirties: FormState<FiltersFormT>["dirtyFields"],
): Partial<FiltersFormT> {
  const commonProps: Partial<FiltersFormT> = {};
  for (const [key, value] of Object.entries(dirties)) {
    if ((Array.isArray(value) && !!value?.length) || (!Array.isArray(value) && !!value)) {
      (commonProps as any)[key] = (data as any)[key];
    }
  }

  return commonProps;
}
